'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { useTranslation } from 'react-i18next';

// UI lib components
import { Group, Title, Avatar } from '@mantine/core';

// Types
import { BrandTagProps } from './types';

// Style
import * as classes from './styles/index.css';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

function BrandTag({ withLogo = false, withText = false }: BrandTagProps) {
  /* ********************************** HOOKS ********************************* */

  // Localization
  const { t } = useTranslation('Common');

  // Style

  /* ******************************** RENDERING ******************************* */
  return (
    <Group>
      {withLogo ? (
        <Avatar alt="Blackroom" src="/images/brand/logo.svg" size="lg" />
      ) : null}
      {withText ? (
        <Group gap={0}>
          {t('brand.name')
            .split('r')
            .map((s: string, i: number) => (i === 1 ? `r${s}` : s))
            .map((c, i) => (
              <Title
                key={c}
                className={classes.title}
                order={4}
                fw={i === 0 ? 700 : 200}
              >
                {c}
              </Title>
            ))}
        </Group>
      ) : null}
    </Group>
  );
}

export default BrandTag;
